<template>
  <g class="legend" >
    <g
       v-for="(key, i) in keys"
       :key="i"
       :transform="'translate(' + x + ',' + i * 20 + ')'" >
      <rect :x="width - 19" width="19" height="19" :fill="key.color" ></rect>
      <ellipsis
         :text="key.label ? key.label : ''"
         :width="width - 24"
         :x="0"
         :y="9.5"
         dy="0.32em"
         textAnchor="start" >
      </ellipsis>
    </g>
  </g>
</template>

<style scoped>
.drag {
    cursor: move;
}
</style>

<script>
import Ellipsis from './Ellipsis.vue'

export default {
  components: {
    Ellipsis: Ellipsis
  },
  props: {
    keys: {
      type: Array,
      required: true
    },
    x: {
      type: Number,
      required: true
    },
    y: {
      type: Number,
      default: 0
    },
    width: {
      type: Number,
      default: 100
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/d3vue/components/Legend.vue